import React, {useContext,useState,useEffect,useRef, startTransition, useMemo } from "react";
import { AppContext } from "../../context/AppContext";
import { IoMdHeart,IoMdHeartEmpty } from "react-icons/io";
import "./containerRestau.css"
import { fetchWithRefreshUser,slugify } from "../types/types";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdOutlineStar } from "react-icons/md";
import { IoPersonSharp } from "react-icons/io5";
import { Link } from "react-router-dom";

interface containerRestauProps {
    id:number,
    idResto:number,
    img : string,
    note: number,
    name: string,
    id_url:string,
    imgSup?:string[],
    isFav:boolean,
    type:string[],
    visibleCity?:string,
    city:string,
    nbr_review:number,
    total_price:number,
    cuisines:[string,string],
    isLarge?:boolean,
    date_published?:Date,
    imgLocked?:boolean,
    isSolo?:boolean
}

const ContainerRestauInner:React.FC<containerRestauProps> = ({id,isLarge=false,imgLocked=false,date_published,id_url,idResto,img,city,visibleCity,note,name,imgSup,isFav,type,nbr_review,total_price,cuisines,isSolo=false}) => {
    const {isLogin,setConnectionScreen,restoFav,setRestoFav} = useContext(AppContext)

    const [fav,setFav] = useState(restoFav.includes(idResto))
    useEffect(() => {
        setFav(restoFav.includes(idResto))
    },[restoFav])
    const [activeImageIndex, setActiveImageIndex] = useState([0,1]);
    const [currentImgPhone, setCurrentImgPhone] = useState(0);

    const canHover = (typeof window !== "undefined" && window.matchMedia("(hover: hover) and (pointer: fine)").matches);

    const [activeIndexPhone,setActiveIndexPhone] = useState([0,1])
    const [activeImgPhone,setActiveImgPhone] = useState([0,1])
    const [isSwipePhone,setIsSwipePhone] = useState(false)

    const [isSlide, setIsSlide] = useState(false)
    const [isHovered, setIsHovered] = useState(false)
    const [isFirst, setIsFirst] = useState(true)
    const [zindexBase,setZindexBase] = useState(-1)
    const containerRef = useRef<HTMLDivElement>(null);
    const timeouts = useRef<NodeJS.Timeout[]>([]);
    const images = useMemo(() => imgSup ? [img,...imgSup] : [img], [img, imgSup]);
    let isNew = false
    if(date_published) {
        const now = Date.now();
        const publishedAt = new Date(date_published).getTime();
        isNew = (now - publishedAt) < 1000 * 60 * 60 * 24 * 14;
    }
    const linkResto = useMemo(() => {
        const slugcity = slugify(city)
        const slugName = slugify(name)
        return  `/restaurant/${slugcity}/${slugName}_${id_url}?src=home`
    },[city,name,id_url])

    useEffect(() => {
        if (window.innerWidth <= 768) return;
        timeouts.current.forEach((timeout) => clearTimeout(timeout));
        timeouts.current = [];
        timeouts.current.push(
        setTimeout(() => {
        if(isHovered && images.length > 1) {
            const slideFirst = document.getElementById('slideFirstRestau'+id)
            const slideSecond = document.getElementById('slideSecondRestau'+id)
            if(isFirst && slideFirst && slideSecond) {
                slideFirst.classList.add('sliding')
                slideSecond.style.zIndex = '0'
                slideSecond.classList.remove('right')
                timeouts.current.push(
                    setTimeout(() => {
                            slideFirst.style.zIndex = '-10'
                            slideFirst.classList.remove('sliding')
                            slideFirst.classList.add('right')
                    },750 ))
                
            }
            else if(!isFirst && slideFirst && slideSecond) {
                slideSecond.classList.add('sliding')
                slideFirst.style.zIndex = '0'
                slideFirst.classList.remove('right')
                timeouts.current.push(
                    setTimeout(() => {
                        slideSecond.style.zIndex = '-10'
                        slideSecond.classList.remove('sliding')
                        slideSecond.classList.add('right')
                    },750 )    
                )  
            }
            timeouts.current.push(
            setTimeout(() => {
                if(isHovered) {
                    if(isFirst) setActiveImageIndex([activeImageIndex[1]+1 >= images.length ? 0 : activeImageIndex[1]+1,activeImageIndex[1]])
                    else setActiveImageIndex([activeImageIndex[0],activeImageIndex[0]+1 >= images.length ? 0 : activeImageIndex[0]+1])
                    setIsFirst(!isFirst)
                }
            },1000)  
            )  
        }
        else if (isHovered) {
            const container = document.getElementById('containerRestau'+id)
            if(container) {
                container.classList.add('noDefilment');
                setTimeout(() => container.classList.remove('noDefilment'), 200);
            }
        }
        else {
            handleMouseLeave()
        }
        return () => {
            timeouts.current.forEach((timeout) => clearTimeout(timeout));
            timeouts.current = [];
          };
        },500))

    },[isHovered,isFirst])




    const handleMouseEnter = () => {
        if (window.innerWidth <= 765) return;
        setIsFirst(true)
        timeouts.current.forEach((timeout) => clearTimeout(timeout));
        timeouts.current = []     
        const slideFirst = document.getElementById('slideFirstRestau'+id)
        const slideSecond = document.getElementById('slideSecondRestau'+id)
        if(slideFirst && slideSecond) {
            slideFirst.style.transition = 'transform 0.7s ease '
            slideSecond.style.transition = 'transform 0.7s ease'
            setZindexBase(-1)
            setIsHovered(true)
        }
    }
    const handleMouseLeave = () => {
        if (window.innerWidth <= 765) return;
        timeouts.current.forEach((timeout) => clearTimeout(timeout));
        timeouts.current = []
        setIsHovered(false)
        setActiveImageIndex([0,1])
        setZindexBase(1)
        const slideFirst = document.getElementById('slideFirstRestau'+id)
        const slideSecond = document.getElementById('slideSecondRestau'+id)
        if(slideFirst && slideSecond) {
            slideFirst.style.transition = 'transform 0.001s linear';
            slideSecond.style.transition = 'transform 0.001s linear';
            slideFirst.style.zIndex='0'
            slideSecond.style.zIndex='0'
            slideFirst.classList.remove('sliding','right')
            slideSecond.classList.remove('sliding')
            slideSecond.classList.add('right') 
        }
            
    }
    const [possibleLike, setPossibleLike] = useState(true)
    const handleFav = async () => {
        if (isLogin === 0) {
            startTransition(() => {setConnectionScreen(true)});
        } else {
            if (possibleLike) {
                try {
                    setPossibleLike(false)
                    const token = localStorage.getItem('token');
                    const response = await fetchWithRefreshUser(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/updateFav`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        credentials: 'include',
                        body: JSON.stringify({idrestaurant: idResto}),
                    });
                    if(fav) setRestoFav(prev => prev.filter(id => id !== idResto));
                    else setRestoFav([...restoFav,idResto])
                    setFav(!fav); 
                    
                    if (!response) {
                        throw new Error('Erreur lors de la mise à jour du favori');
                    }
                    
                    setTimeout(() => {
                        setPossibleLike(true)
                    },1000)
                } catch (error) {
                    console.error("Erreur lors de la mise à jour en base de données", error);
                }
            }
        }
    }
    const touchStartX= useRef(0);
    const touchStartY= useRef(0);
    
    const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
        e.stopPropagation();
        setIsSlide(true)
        if (canHover) return;
        touchStartX.current = e.touches[0].clientX;
        touchStartY.current = e.touches[0].clientY;
    };

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const handleMove = (e: TouchEvent) => {
            if (canHover) return;
            if (touchStartX.current === null || touchStartY.current === null) return;

            const touchX = e.touches[0].clientX;
            const touchY = e.touches[0].clientY;
            const deltaX = touchX - touchStartX.current;
            const deltaY = touchY - touchStartY.current;

            if (Math.abs(deltaX) > Math.abs(deltaY) * 1.2 && e.cancelable) {
                e.preventDefault(); 
            }
        };

        container.addEventListener('touchmove', handleMove, { passive: false });

        return () => {
            container.removeEventListener('touchmove', handleMove);
        };
    }, [containerRef]);


    const updateUpInfo = (prevId:number) => {
        return prevId+1 >= images.length ? 0 : prevId+1;
    }
    const updateDownInfo = (prevId:number) => {
        return prevId-1 < 0 ? images.length-1 : prevId-1;
    }
    const preloadImage = (src: string) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = resolve;
            img.src = src;
        });
    };
    const handleTouchEnd = async (e: React.TouchEvent<HTMLDivElement>) => {
        e.stopPropagation();
        if (canHover || images.length === 1 || isSwipePhone) return;
        setIsSwipePhone(true)
        const touchEndX = e.changedTouches[0].clientX;
        const distance = touchEndX - touchStartX.current;
        const distanceY = e.changedTouches[0].clientY - touchStartY.current;
        try {
            const slideCenter = document.getElementById('slideRestauPhone' + activeIndexPhone[0] + id);
            const slideOther = document.getElementById('slideRestauPhone' + activeIndexPhone[1] + id);

            if (Math.abs(distance) < 50 || !slideCenter || !slideOther || Math.abs(distance) < Math.abs(distanceY)) {
                setIsSwipePhone(false);
                return;
            }
    
            slideOther.style.zIndex = '0';
            slideOther.style.transition = '0s';
            slideOther.classList.remove('moveLeft', 'moveRight');
    
            const direction = distance < 0 ? 'Left' : 'Right';
            const updateImgFn = distance < 0 ? updateUpInfo : updateDownInfo;
    
            slideOther.classList.add(direction === 'Left' ? 'moveRight' : 'moveLeft');

            const newIndex = updateImgFn(activeImgPhone[activeIndexPhone[0]]);
            const newSrc = images[newIndex];

            await preloadImage(newSrc); 

            setActiveImgPhone((prev) =>
            prev.map((item, index) => (index === activeIndexPhone[1] ? newIndex : item))
            );

            setTimeout(() => {
                slideOther.style.zIndex = '1';
                slideCenter.style.zIndex = '1';
                slideCenter.style.transition = 'transform 0.75s ease';
                slideOther.style.transition = 'transform 0.75s ease';
    
                slideCenter.classList.add(direction === 'Left' ? 'moveLeft' : 'moveRight');
                slideOther.classList.remove(direction === 'Left' ? 'moveRight' : 'moveLeft');
    
                setActiveIndexPhone([activeIndexPhone[1], activeIndexPhone[0]]);
                setCurrentImgPhone(updateImgFn(currentImgPhone));
            }, 10);
        } finally {
            setTimeout(() => {
                setIsSwipePhone(false);
            }, 750);
        }
    };

    const handleCurrentImg = (index:number) => {
        setCurrentImgPhone(index)
        setActiveImgPhone([index,activeImgPhone[1]])
    }

    return (
        <div className={`containerRestauUp ${isSolo ? 'isSolo' : ''} ${id%3 !== 0 && 'notFirst'} ${isLarge && 'large'} ${canHover ? 'canHover' : 'cantHover'}`}>
            {images.length > 1 && <div className="slideImgPhone" style={{width: images.length > 4 ? '15%' : (images.length > 3 ? '13%' : images.length > 2 ? '10%' : '8%') }}>
                    {
                        images.map((elem,id) => {
                            return <div key={'elemSlidephone'+id} className={`${currentImgPhone === id && 'select'} ${(currentImgPhone === id+1 || currentImgPhone === id-1) && 'nextSelect'}`} onClick={() => {if(currentImgPhone !== id){handleCurrentImg(id)}}}>

                            </div>
                        })
                    }
                </div>}
            <Link to={linkResto} state={{ skipSplash: true }} target="_blank" rel="noopener" className='containerRestau' id={`containerRestau`+id}  onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} >
                 {canHover ? <>
                <div className="slideBase forComputer" id={'slideBaseRestau'+id} style={{zIndex:zindexBase}} >
                    {images[activeImageIndex[0]] && !imgLocked && <img src={images[activeImageIndex[0]]} loading={id === 0 ? "eager" : "lazy"} {...(id === 0 && { fetchpriority: 'high' })} alt="illustration du restaurant"/> }
                </div>
                <div className="slideFirst forComputer" id={'slideFirstRestau'+id} >
                    {images[activeImageIndex[0]] && isHovered &&  <img  src={images[activeImageIndex[0]]} loading="lazy"  decoding="async" alt="illustration du restaurant"/>}
                </div>
                <div className="slideSecond right forComputer"  id={'slideSecondRestau'+id} >
                    { isHovered && <img  src={images[activeImageIndex[1]]} loading="lazy"  decoding="async" alt="illustration du restaurant"/> }
                </div></> :

                <div onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}  ref={containerRef}> 
                    <div className="slideFirst forPhone " id={`slideRestauPhone0`+id} >
                        { !imgLocked && <img key={images[activeImgPhone[0]]} src={images[activeImgPhone[0]]} loading={id === 0 ? "eager" : "lazy"}  alt="illustration du restaurant" {...(id === 0 && { fetchpriority: 'high' })}/> }
                    </div>

                    <div className="slideSecond forPhone moveRight"  id={`slideRestauPhone1`+id} >
                       {isSlide && <img key={images[activeImgPhone[1]]} src={images[activeImgPhone[1]]} loading="lazy"  decoding="async" alt="illustration du restaurant"/>
                    }</div>
                </div> }
                
                <div className="footerContainerRestau" >
                    <div className="infoNameNew">
                        <h3 className={`title midTitle ${name.length > 26 && 'lng'}`} translate="no">{name}</h3>
                        {isNew && <p className="isNew smallTitle" style={{fontStyle:"italic"}}>{name.length > 26 ? 'NOUV. !' : 'NOUVEAU !'}</p>}
                    </div>
                    <div className="separation"></div>
                    <div className="leftPart">
                        <h4 className="type XsmallText" ><i>{type}</i></h4>
                        <p className="cuisines smallText">{cuisines[0] && <i>{`Cuisine${cuisines[1] && 's'} ${cuisines[0]}${cuisines[1] && ` et ${cuisines[1]}` }`}</i> }</p>
                        <h4 className="city XsmallText" style={{color:"#606060"}} ><FaMapMarkerAlt color="#959595" size={10} className="icon"/> {visibleCity ? visibleCity : city}</h4>
                    </div>
                    <div className="rightPart XsmallText">
                        <div className="midTextBold">
                            <p style={{marginRight:'5px',marginTop:'3px',color:"#2C2B2B"}}> {Number(note) !== 0 ? (Number(note) % 1 === 0 ? Number(note).toFixed(0) : Number(note).toFixed(1)) : ''}</p>
                            <MdOutlineStar  className="baseRate"  color="#cb9e3A" size={23} />
                            <MdOutlineStar  className="rateSmallComputer"  color="#cb9e3A" size={18} />
                        </div>
                        <div style={{color:"#737373"}}>{`(${nbr_review} ${nbr_review <2 ? 'avis' : 'avis'})`}</div>
                        <div>
                            <p>≈ {Math.round(total_price)}€ /</p> 
                            <IoPersonSharp color="#959595"  size={10}/>
                        </div>
                    </div>
                    
                </div> 
                {   
                    isLogin !== 2 && <div className="heart pointer">
                        {!fav && <IoMdHeartEmpty className=" lowOpacityHover scndHeart" style={{zIndex:2,opacity:0.9}}  color={'white'} onClick={(e) => {e.preventDefault();e.stopPropagation();handleFav()}} size={35} />}
                        <IoMdHeart className=" lowOpacityHover " style={{zIndex:1,opacity:fav ? 1: 0.6}}  color={` ${fav  ? 'red' : 'black'}`} onClick={(e) => {e.preventDefault();e.stopPropagation();handleFav()}} size={35} />
                    </div>
                }
            </Link>       
        </div>
    )
}
const ContainerRestau = React.memo(ContainerRestauInner);

export { ContainerRestau }